/* registerIcons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("power.button.on", require("./rawicons/power.on.svg"));
IconRegistry.registerIcon("power.button.off", require("./rawicons/power.off.svg"));
